import { render, staticRenderFns } from "./LensSettings.vue?vue&type=template&id=81d1f7f4&scoped=true"
import script from "./LensSettings.vue?vue&type=script&lang=js"
export * from "./LensSettings.vue?vue&type=script&lang=js"
import style0 from "./LensSettings.vue?vue&type=style&index=0&id=81d1f7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d1f7f4",
  null
  
)

export default component.exports